import * as React from 'react';
import type { SVGProps } from 'react';
type ZinniaSvgProps = SVGProps<SVGSVGElement> & {
  size: number | string,
};
const SvgActionFlag = (props: ZinniaSvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    height={props.size}
    width={props.size}
    {...props}
  >
    <path
      fill="#2D2E2E"
      d="M10.66 5H5.39L1.75 15h7.39l.73-2h5.28l.73-2H10.6l2.18-6h6.87l-5.82 16h2.13l6.55-18H11.39l-.73 2Zm-2.91 8H4.6l2.18-6h3.14l-2.17 6Z"
    />
  </svg>
);
export default SvgActionFlag;
